<template>
	<div class="container" id="FeelingsLog">
		<div class="text-center gold mt-4">
			<h3>
				Chart Data:
				<router-link :to="'/dashboard/' + this.$store.state.profile_active.id" class="">
					<small v-text="this.$store.state.profile_active.user_name"></small>
				</router-link>
			</h3>
		</div>

		<div class="row mb-4 pb-2 border-bottom">
			<div class="col-md-4">
				<b-form-datepicker
					placeholder="Start Date"
					v-model="dates.start.selected"
					:min="dates.start.min"
					:max="dates.start.max"
				>
				</b-form-datepicker>
			</div>
			<div class="col-md-4">
				<b-form-datepicker
					placeholder="End Date"
					v-model="dates.end.selected"
					:min="dates.end.min"
					:max="dates.end.max"
				>
				</b-form-datepicker>
			</div>
			<div class="col-md-2">
				<b-form-select v-model="range_select" :options="range_options"> </b-form-select>
			</div>
			<div class="col-md-2">
				<b-button block variant="outline-primary" @click="date_refresh">
					Refresh <i class="fas fa-sync-alt"></i>
				</b-button>
			</div>
		</div>

		<!-- <div class="row mb-4 pb-2 border-bottom">
			<div class="col-12 text-right">
				<DownloadCSVButton
					:userid="this.$route.params.user_id"
					class_style="btn btn-sm btn-outline-primary"
					text="User CSV"
				/>
			</div>
		</div> -->

		<div>
			<div v-if="chart.loading == 0">
				<chart-bar :chartdata="chart.chartdata" />

				<div class="m-4 small text-muted">
					<ul v-html="chart.notes"></ul>
				</div>
			</div>
			<div v-else class="spinner">
				<i class="fas fa-spinner fa-spin fa-2x"></i>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import ChartBar from '../components/ChartBar.vue';
/*import DownloadCSVButton from '../components/DownloadCSVButton.vue';*/

export default {
	name: 'ChartData',
	components: {
		ChartBar,
	},

	data() {
		const today = new Date().toISOString().slice(0, 10);
		var now = new Date();
		var weeks = 6;
		var weeksAgo = weeks * 7;
		now.setDate(now.getDate() - weeksAgo);
		const startDate = now.toISOString().slice(0, 10);

		return {
			chart: {
				chartdata: {},
				loading: 1,
				metrics: this.$route.params.metrics,
				type: this.$route.params.type,
				notes: '',
			},
			dates: {
				end: {
					min: null,
					max: today,
					selected: today,
				},
				start: {
					min: null,
					max: today,
					selected: startDate,
				},
			},
			range_options: [
				{ value: 'Monthly', text: 'Monthly' },
				{ value: 'Weekly', text: 'Weekly' },
				{ value: 'Daily', text: 'Daily' },
			],
			range_select: 'Weekly',
		};
	},

	methods: {
		activeProfileSet() {
			var profile = {
				id: this.$route.params.user_id,
			};

			this.$store.commit('profileActiveSet', profile);
		},

		date_refresh() {
			this.chart.chartdata = {};
			this.chart.loading = 1;
			this.loadPageData();
		},

		loadPageData() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('type', _this.chart.metrics);
			params.append('user_id', _this.$route.params.user_id);
			params.append('range', _this.range_select);
			params.append('start_date', _this.dates.start.selected);
			params.append('end_date', _this.dates.end.selected);

			axios({
				url: _this.$store.state.api_url + 'ChartDataGet',
				params: params,
			})
				.then(function (response) {
					_this.chart.chartdata = response.data.data.chartdata;
					_this.chart.notes = response.data.data.notes;

					_this.$store.commit('profileActiveSet', response.data.profile);

					_this.chart.loading = 0;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},

	mounted() {
		this.loadPageData();
	},

	computed: {},
	watch: {},
};
</script>

<style scoped>
.spinner {
	text-align: center;
	margin: 2rem;
	color: #ccc;
}
</style>
